import React from 'react';
import Header from './../Header/Header';
import Footer from './../Footer/Footer';
import ImportantMessages from './../ImportantMessages/ImportantMessagesContainer';
import env from '../../env';
import ErrorBoundary from 'app/components/ErrorHandler/ErrorBoundary';
import { ReactBase, MainContent } from './BaseLayout.styles';
import { useRouter } from 'next/router';
import { ReactHelmetPlayApplication } from '../ApplicationHandler/ReactHelmet';
import SurveyContainer from 'app/components/Survey/SurveyContainer';
import GlobalStyles from './GlobalStyles';

type Props = {
    mainClassName?: string;
    children: any;
    videoModalOpen: boolean;
};

const BaseLayout = ({ children }) => {
    const router = useRouter();
    const videoModalOpen = Boolean(router.query.modalId);

    return (
        <>
            <GlobalStyles videoModalOpen={videoModalOpen} />
            <ReactBase videoModalOpen={videoModalOpen} aria-hidden={videoModalOpen}>
                <ReactHelmetPlayApplication router={router} />
                <div id="play_a11y-announcer" className="play_visually-hidden" aria-live="assertive"></div>
                <div id="fb-root" data-appid={env.FB_APP_ID}></div>
                <div className={'play_root-container'}>
                    <ImportantMessages />
                    <div className="play_root">
                        <Header />

                        <SurveyContainer />
                        <ErrorBoundary>
                            <MainContent id="play_main-content" tabIndex="-1">
                                {children}
                            </MainContent>
                        </ErrorBoundary>

                        <Footer />
                    </div>
                </div>
            </ReactBase>
        </>
    );
};

export const BaseLayoutWrapper = ({ children, videoModalOpen }) => {
    return (
        <ReactBase videoModalOpen={videoModalOpen} aria-hidden={videoModalOpen}>
            {children}
        </ReactBase>
    );
};

export default BaseLayout;
